import axios from '@/utilities/axios-global'

export function GET_CODING_QUESTIONS(context) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/codingquestions').then(response => {
      context.commit('SET_CODING_QUESTIONS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_CODING_QUESTION_STATUS_LIST(context) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/codingquestions/status`).then(response => {
      context.commit('SET_CODING_QUESTION_STATUS_LIST', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_CONSULTANT_LIST(context) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/codingquestions/consultants`).then(response => {
      context.commit('SET_CONSULTANT_LIST', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_CODING_QUESTION(context, id) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/codingquestions/${id}`).then(response => {
      context.commit('SET_CODING_QUESTION', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_CODING_QUESTION(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/codingquestions`, payload).then(response => {
      context.commit('SET_CODING_QUESTION', response.data)
      resolve(response.data)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_ATTACHMENT(context, payload) {
  return new Promise((resolve, reject) => {
    if (payload.attachment.size > 524288000) {
      // eslint-disable-next-line
      reject({ response: { data: { message: 'Files size cannot be greater than 500 MB' } } })
      return
    }

    // we need to use a special endpoint and FormData here
    // to make the browser stream the file directly to the server instead
    // of storing it in local memory
    let formData = new FormData()
    formData.append('attachment', payload.attachment)
    formData.append('name', payload.name)
    formData.append('directory', payload.directory)

    axios.post(context.rootState.user.baseApiUrl + `/codingquestions/${payload.questionId}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress: payload.onUploadProgress }).then(response => {
      context.commit('PUSH_CODING_QUESTION_ATTACHMENT', response.data)
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_ATTACHMENT(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(context.rootState.user.baseApiUrl + `/codingquestions/${payload.questionId}/attachments/${payload.attachmentId}`).then(response => {
      context.commit('SPLICE_ATTACHMENT', payload)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_ATTACHMENT_LINK(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/codingquestions/${payload.questionId}/attachments/${payload.attachmentId}/download-link`).then(response => {
      resolve(response.data)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_CODING_QUESTION(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/codingquestions/${payload.codingQuestion.questionId}?changedField=${payload.changedField}`, payload.codingQuestion).then(() => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_CODINGQUESTION_PDF_URL(context, questionId) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/codingquestions/${questionId}/downloadbuilder`).then(response => {
      const fileUrl = encodeURIComponent(`${context.rootState.user.baseApiUrl}${response.data}`)
      resolve(fileUrl)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_CODING_QUESTION_COMMENT(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/codingquestions/${payload.questionId}/comments`, payload).then(response => {
      context.commit('PUSH_CODING_QUESTION_COMMENT', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export default {
  GET_CODING_QUESTIONS,
  GET_CODING_QUESTION,
  GET_CODING_QUESTION_STATUS_LIST,
  GET_CONSULTANT_LIST,
  POST_CODING_QUESTION,
  PUT_CODING_QUESTION,
  POST_CODING_QUESTION_COMMENT,
  POST_ATTACHMENT,
  DELETE_ATTACHMENT,
  GET_ATTACHMENT_LINK,
  GET_CODINGQUESTION_PDF_URL
}
